import appSignalRService from "./appSignalRService";

/**
 * 监听安全报警推送
 * @param {function} callBack 回调函数
 */
export function onSecurity(callBack) {
    appSignalRService.on('security', callBack);
}

/**
 * 取消监听安全报警推送
 * @param {function} callBack 回调函数
 */
export function offSecurity(callBack) {
    appSignalRService.off('security', callBack);
}

/**
 * 监听净空推送
 * @param {function} callBack 回调函数
 */
export function onClearance(callBack) {
    appSignalRService.on('Clearance', callBack);
}

/**
 * 取消监听净空推送
 * @param {function} callBack 回调函数
 */
export function offClearance(callBack) {
    appSignalRService.off('Clearance', callBack);
}
